module.exports = __webpack_public_path__ + "static/media/computer_screen_frame.77baa30b.png";